import { COURIER_ADDRESS_CODE, COURIER_ADDRESS_LABEL, DYNAMIC_DATA_FORMAT_INDEX, DYNAMIC_DATA_SPLITTER, DYNAMIC_DATA_VALUE_INDEX, KG_CONVERT_FACTOR, LB_CONVERT, MOVEMENT_STATUS, MOVEMENT_STATUS_CODES, WEIGTH_ROUND_FACTOR } from "./Constants";

export const toNumberFormat = (value) => {
    const number = Number(value);
    return number.toFixed(2);
}

export const getLbsWeight = (weigth = "0:kg") => {
    const lbsRegex = RegExp('lb', 'i');

    let lbWeight = new Number(0);
    if (lbsRegex.test(weigth)) {
        lbWeight = Number(weigth.split(DYNAMIC_DATA_SPLITTER)[DYNAMIC_DATA_VALUE_INDEX] || 0);
    } else if (weigth != null) {
        const kgWeight = Number(weigth.split(DYNAMIC_DATA_SPLITTER)[DYNAMIC_DATA_VALUE_INDEX] || 0);
        lbWeight = kgWeight * Number(KG_CONVERT_FACTOR);
    }
    return `${lbWeight.toFixed(2)}:lb`;
}

export const getKgWeight = (weight = "0:kg") => {
    const lbsRegex = /lb/i;

    let kgWeight = 0;
    if (lbsRegex.test(weight)) {
        const lbValue = Number(
            weight.split(DYNAMIC_DATA_SPLITTER)[DYNAMIC_DATA_VALUE_INDEX] || 0
        );
        kgWeight = lbValue * Number(LB_CONVERT);
    } else if (weight != null) {
        kgWeight = Number(
            weight.split(DYNAMIC_DATA_SPLITTER)[DYNAMIC_DATA_VALUE_INDEX] || 0
        );
    }

    return `${kgWeight.toFixed(3)}:kg`;
};

export const getPackageFinalWeight = (
    weight = "",
    vweight = "0:kg"
) => {
    const kgRegex = /kg/i;

    const calculatedVweight = getKgWeight(vweight);
    const calculatedWeight = getKgWeight(weight);

    const vweightMeasure =
        calculatedVweight.split(DYNAMIC_DATA_SPLITTER)[DYNAMIC_DATA_FORMAT_INDEX] || "";
    const weightMeasure =
        calculatedWeight.split(DYNAMIC_DATA_SPLITTER)[DYNAMIC_DATA_FORMAT_INDEX] || "";

    if (
        kgRegex.test(vweightMeasure) &&
        kgRegex.test(weightMeasure)
    ) {
        const vweightValue = Number(
            calculatedVweight.split(DYNAMIC_DATA_SPLITTER)[DYNAMIC_DATA_VALUE_INDEX] || 0
        );
        const weightValue = Number(
            calculatedWeight.split(DYNAMIC_DATA_SPLITTER)[DYNAMIC_DATA_VALUE_INDEX] || 0
        );
        const maxWeight = Math.max(vweightValue, weightValue);
        return customRound(maxWeight, WEIGTH_ROUND_FACTOR);
    }

    return 0;
};

export const getPackageFinalWeightFromLbs = (weigth = "", vweigth = "0:lb") => {
    const lbsRegex = RegExp('lb', 'i');
    const calculatedVweight = getLbsWeight(vweigth);
    const calculatedWeight = getLbsWeight(weigth);
    const vweigthMeasure = getLbsWeight(calculatedVweight).split(DYNAMIC_DATA_SPLITTER)[DYNAMIC_DATA_FORMAT_INDEX] || "";
    const weigthMeasure = getLbsWeight(calculatedWeight).split(DYNAMIC_DATA_SPLITTER)[DYNAMIC_DATA_FORMAT_INDEX] || "";

    if (vweigthMeasure && weigthMeasure &&
        lbsRegex.test(vweigthMeasure) && lbsRegex.test(weigthMeasure)) {
        const vweigthValue = calculatedVweight.split(DYNAMIC_DATA_SPLITTER)[DYNAMIC_DATA_VALUE_INDEX] || null;
        const weigthValue = calculatedWeight.split(DYNAMIC_DATA_SPLITTER)[DYNAMIC_DATA_VALUE_INDEX] || null;
        const maxWeigth = Math.max(vweigthValue, weigthValue);
        return customRound(maxWeigth, WEIGTH_ROUND_FACTOR);
    }
    return 0;
}

export const customRound = (value, step = 1.0) => {
    let inv = 1.0 / step;
    return Math.round(value * inv) / inv;
}

export const getSummaryData = (packageCostData) => {
    return [
        {
            "label": "Subtotal",
            "value": packageCostData?.subtotal || 0,
        },
        {
            "label": "Descuento",
            "hideIfZero": true,
            "value": packageCostData?.discount || 0,
        },
        {
            "label": "Iva",
            "value": packageCostData?.iva || 0,
        },
        {
            "label": "Total",
            "value": packageCostData?.total || 0,
        }
    ]
}

export const getPackageStatus = (box) => {
    if (box.isDelivered) {
        return MOVEMENT_STATUS[MOVEMENT_STATUS_CODES.DELIVERIED];
    } else if (box.received && !box.cargoMovement) {
        return MOVEMENT_STATUS.received;
    } else {
        const defaultStatus = MOVEMENT_STATUS.onWait;
        return box.cargoMovement ? MOVEMENT_STATUS[box.cargoMovement.status] : defaultStatus;
    }
}

export const getAddressOptions = (addresses) => {
    let addressList = {
        [COURIER_ADDRESS_CODE]: COURIER_ADDRESS_LABEL
    };

    const addressesOptions = addresses.reduce((a, address) => {
        a[address.id] = address.name;
        return a;
    }, {});
    addressList = {
        ...addressList,
        ...addressesOptions,
    };

    return addressList;
}